module.exports = __webpack_public_path__ + "static/img/bg-en.3eab9d7e.png";